import ajax from '../assets/js/ajax'
const actions = {
  listResume (ctx, params) {
    return ajax.get('/zhaopin/b/jobapply/list.json', params)
  },
  changeApplyStatus (ctx, params) {
    return ajax.post('/zhaopin/b/jobapply/chgstatus.json', params)
  },
  getResumeByApplyId (ctx, params) {
    return ajax.get('/zhaopin/b/jobapply/info.json', params)
  }
}
export default {
  actions
}



// WEBPACK FOOTER //
// ./src/store/resume.js